import React, {useEffect, useState } from "react";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableRow from "@mui/material/TableRow";
import {MoneyFormatv3 } from "../../../library/MoneyFormat";
import { useStateList } from "../Components/HandleInvoiceStateProvider";
function TotalAmountsTable({
  nonItems,
  nonItemEditedRow,
  nonItemTempRow,
  setNonItems,
  setNonItemEditedRow,
  setNonItemTempRow,
  setItems,
  items,
  itemTempRow,
  setItemTempRow,
  itemEditedRow,
  setItemEditedRow,
  rowIndex,
  nonRowIndex,
  totTaxAmt,
  setTotTaxAmt,
  totDiscount,
  setTotDicount,
  totGSTCess,
  setTotGSTCess,
  totNetAmt,
  setTotNetAmt,
  totGST,
  setTotGST,
  totAmt,
  setTotAmt,
  data,
  setData,
  setInitialState,
  Type,
  registrationType,
  companyData,
  tabelCellClass,
  partyType,
  netAmountToPay,
  setNetAmountToPay
  
}) {
  const [totalDisplayAmt,setTotalDisplayAmt]=useState(0) //LEDX-4673
  const taxTypes =
    partyType === "CUSTOMER" || Type === "Pos"
      ? [2, 3, 5, 4, 7, 9]
      : [2, 3, 5, 7, 9]; //LEDX-4673
  const {viewMode}=useStateList()
//   function displayEntryAmount() {
   
//     let itemArr = [...items];
//     let nonItemArr = [...nonItems];
//     let totalAmount = 0;
//     let totalDiscount = 0;
//     let totalTaxAmount = 0;
//     let totalGst = 0;
//     let totalCess = 0;
//     let totalNetAmount = 0;
//     itemArr.map((ele) => {
//       // if (ele.editable !== true) {
//       totalAmount += Number(ele.amount === undefined ? 0 : ele.amount);
//       totalDiscount += Number(ele.dicount === undefined ? 0 : ele.dicount);
//       totalTaxAmount += Number(
//         ele.taxableAMount === undefined ? 0 : ele.taxableAMount
//       );
//       totalGst += Number(ele.IGST || 0);
//       totalCess += Number(ele.GSTCess || 0);

//       totalNetAmount +=
      
//         registrationType !== 3
//           ? Number(ele.netAmount)
//           : Number(ele.taxableAMount)

//       // }
//     });


//     totalAmount =
      
//       Number(totalAmount);
//     totalDiscount =

//       Number(totalDiscount);
//     setTotDicount(totalDiscount);
//     totalTaxAmount =
    
//       Number(totalTaxAmount);
//     totalGst =
//       Number(totalGst)
    
//     totalCess =
//       Number(totalCess)
  
//     totalNetAmount =
//       Number(totalNetAmount)
   
//     nonItemArr.map((ele) => {
//       if (ele.taxableAMount !== 0
       
//       ) {
//         totalAmount += Number(ele.taxableAMount);
//         totalTaxAmount += Number(ele.taxableAMount);
//         totalGst += Number(ele.IGST);
//         totalCess += Number(ele.GSTCess);
//         totalNetAmount +=
        
//           registrationType !== 3
//             ? Number(ele.netAmount)
            
//             : Number(ele.taxableAMount)

//       }
//     });
//     setTotAmt(
      
//       Number(totalAmount)
//     );
//     setTotTaxAmt(
   
//       Number(totalTaxAmount)
//     );

//     totalGst =
//       Number(totalGst)


//     setTotGST(totalGst);
//     setTotGSTCess(
//       Number(totalCess)
    
//     );
//     setTotNetAmt(
//       Number(totalNetAmount)
      
//     );
//     if (registrationType !== 3) {
//       setTotNetAmt(
//         Number(totalNetAmount)
       
//       );
//     } else {
 
//       setTotNetAmt(
//         Number(totalTaxAmount)
       
//       );
     
//     }
//     //LEDX-4673
//     const isTaxExcluded =
//   (registrationType === 3 && partyType === "CUSTOMER") ||
//   (data.reverseChargeFlag === 1 &&
//     (partyType === "CUSTOMER" || Type === "Pos")) ||
//   taxTypes.includes(data?.taxability?.value);

// const totalDisplayAmount = isTaxExcluded
//   ? MoneyFormatv3(Number(totalTaxAmount).toFixed(2), "en-IN")
//   : MoneyFormatv3(Number(totalTaxAmount + totalGst + totalCess).toFixed(2), "en-IN");
//   setTotalDisplayAmt(totalDisplayAmount)
//   }
function displayEntryAmount() {
  // LEDX-4673
  const isTaxExcluded =
    (registrationType === 3 && partyType === "CUSTOMER") ||
    (data.reverseChargeFlag === 1 &&
      (partyType === "CUSTOMER" || Type === "Pos")) ||
    taxTypes.includes(data?.taxability?.value);

  let totalAmount = 0;
  let totalDiscount = 0;
  let totalTaxAmount = 0;
  let totalGst = 0;
  let totalCess = 0;
  let totalNetAmount = 0;

  const itemArr = [...items];
  const nonItemArr = [...nonItems];

  itemArr.forEach((ele) => {
    totalAmount += Number(ele.amount ?? 0);
    totalDiscount += Number(ele.dicount ?? 0);
    totalTaxAmount += Number(ele.taxableAMount ?? 0);
    totalGst += Number(ele.IGST ?? 0);
    totalCess += Number(ele.GSTCess ?? 0);

    // LEDX-4673
    totalNetAmount += isTaxExcluded
      ? Number(ele.taxableAMount ?? 0)
      : Number(ele.netAmount ?? 0);
  });

  nonItemArr.forEach((ele) => {
    if (Number(ele.taxableAMount) !== 0) {
      totalAmount += Number(ele.taxableAMount);
      totalTaxAmount += Number(ele.taxableAMount);
      totalGst += Number(ele.IGST ?? 0);
      totalCess += Number(ele.GSTCess ?? 0);

      // LEDX-4673
      totalNetAmount += isTaxExcluded
        ? Number(ele.taxableAMount ?? 0)
        : Number(ele.netAmount ?? 0);
    }
  });

  setTotDicount(Number(totalDiscount));
  setTotAmt(Number(totalAmount));
  setTotTaxAmt(Number(totalTaxAmount));
  setTotGST(Number(totalGst));
  setTotGSTCess(Number(totalCess));
  setTotNetAmt(Number(totalNetAmount));
  // setNetAmountToPay(totalNetAmount);
  const totalDisplayAmount = isTaxExcluded
    ? MoneyFormatv3(Number(totalTaxAmount).toFixed(2), "en-IN")
    : MoneyFormatv3(
        Number(totalTaxAmount + totalGst + totalCess).toFixed(2),
        "en-IN"
      );

  setTotalDisplayAmt(totalDisplayAmount);
}
   
  function dispalyAmountLabels() {
    if (totTaxAmt > 0) {
      let adjustments = 0;
      let tdsAmount = 0;
      let tcsAmount = 0;
      adjustments =
        data.adjustmentsType == 1
          ? (Number(totTaxAmt) * Number(data.adjustmentsValue)) / 100
          : Number(data.adjustmentsValue);
      tdsAmount = (Number(totTaxAmt) * Number(data.tdsPercent)) / 100;
      tcsAmount = (Number(totTaxAmt) * Number(data.tcsPercent)) / 100;
      setData((prev) => ({
        ...prev,
        adjustments: Number(adjustments).toFixed(2),
        tdsAmount: Number(data.manualTDSAmt) > 0 ? Number(data.manualTDSAmt).toFixed(2) : Number(tdsAmount).toFixed(2),
        tcsAmount: Number(data.manualTCSAmt) > 0 ? Number(data.manualTCSAmt).toFixed(2) : Number(tcsAmount).toFixed(2),
      }));
      if (setInitialState) {
        setInitialState((prev) => ({
          ...prev,
          adjustments: Number(adjustments).toFixed(2),
          tdsAmount: Number(data.manualTDSAmt) > 0 ? Number(data.manualTDSAmt).toFixed(2) : Number(tdsAmount).toFixed(2),
          tcsAmount: Number(data.manualTCSAmt) > 0 ? Number(data.manualTCSAmt).toFixed(2) : Number(tcsAmount).toFixed(2),
        }));
      }

    } else {
      setData((prev) => ({
        ...prev,
        adjustments: 0,
        tdsAmount: 0,
        tcsAmount: 0,
      }));
      if (setInitialState) {
        setInitialState((prev) => ({
          ...prev,
          adjustments: 0,
          tdsAmount: 0,
          tcsAmount: 0,
        }));
      }
    }
  }
  
  useEffect(() => {
    dispalyAmountLabels();
  }, [totTaxAmt]);
  useEffect(() => {
    displayEntryAmount();
  }, [data, items, nonItems]);

  return (
    <>
      <TableBody
       className={viewMode === true ? "disable-interactions !mportant" : ""}>
    
        <TableRow sx={{ height: "40px" }} className={tabelCellClass.table}>
          <TableCell
            sx={{ fontWeight: 600 }}
            // colSpan={
            //   (registrationType !== 1
            //     ? companyData?.relatedcompanydetailsnew?.[0]
            //       ?.gstcompensationcessflag === 1
            //       ? Type === "Sales" || Type === "Purchase" || Type === "Pos"
            //         ? 11 - (data?.taxability?.value !== 2 && data?.taxability?.value !== 3 && data?.taxability?.value !== 5 ? 0 : 3)
            //         : 12 - (data?.taxability?.value !== 2 && data?.taxability?.value !== 3 && data?.taxability?.value !== 5 ? 0 : 3)
            //       : Type === "Sales" || Type === "Pos"
            //         ? 11 - (data?.taxability?.value !== 2 && data?.taxability?.value !== 3 && data?.taxability?.value !== 5 ? 0 : 2)
            //         : Type === "Purchase"
            //           ? 11 - (data?.taxability?.value !== 2 && data?.taxability?.value !== 3 && data?.taxability?.value !== 5 ? 0 : 3)
            //           : 12 - (data?.taxability?.value !== 2 && data?.taxability?.value !== 3 && data?.taxability?.value !== 5 ? 0 : 3)
            //     : Type === "Sales" || Type === "Purchase" || Type === "Pos"
            //       ? 9
            //       : 10) - (partyType === "CUSTOMER" ? 0 : 1)
            // }
            colSpan={
              (registrationType !== 1
                ? companyData?.relatedcompanydetailsnew?.[0]?.gstcompensationcessflag === 1
                  ? Type === "Sales" || Type === "Purchase" || Type === "Pos"
                    ? 11
                    : 12
                  : Type === "Sales" || Type === "Pos"
                    ? 11
                    : Type === "Purchase"
                    ? 11
                    : 12
                : Type === "Sales" || Type === "Purchase" || Type === "Pos"
                  ? 9
                  : 10)-(data?.taxability?.value !== 2 &&
                    data?.taxability?.value !== 3 &&
                    data?.taxability?.value !== 5 ?0:1)
                    // -(partyType === "CUSTOMER" ? 0 : 1)
                
            }
          >
            Total {data.currency.sign}
          </TableCell>
          {registrationType !== 1 && !(registrationType === 3 && (Type === "Sales" || Type === "Pos" || partyType === "CUSTOMER")) && (
            <>
              <TableCell
                sx={{ fontWeight: 600, fontSize: "14px" }}
                align="right"
              >
                {MoneyFormatv3(Number(totTaxAmt).toFixed(2), "en-IN")}
              </TableCell>
           
                        {data?.taxability?.value !== 2 &&
                          data?.taxability?.value !== 3 &&
                          data?.taxability?.value !== 5 && (
              <TableCell
                sx={{ fontWeight: 600, fontSize: "14px" }}
                align="right"
              >
                {MoneyFormatv3(Number(totGST).toFixed(2), "en-IN")}
              </TableCell>)}
              {((Type !== "Sales" && Type !== "Pos") ||
                            companyData?.relatedcompanydetailsnew?.[0]
                              ?.gstcompensationcessflag !== 0) &&
                            data?.taxability?.value !== 2 &&
                            data?.taxability?.value !== 3 &&
                            data?.taxability?.value !== 5 && (
                  <TableCell
                    sx={{ fontWeight: 600, fontSize: "14px" }}
                    align="right"
                  >
                    {MoneyFormatv3(Number(totGSTCess).toFixed(2), "en-IN")}
                  </TableCell>
                )}
            </>
          )}
          <TableCell sx={{ fontWeight: 600, fontSize: "14px" }} align="right">
            {/* {MoneyFormatv3(Number(totTaxAmt+totGST+totGSTCess).toFixed(2), "en-IN")} */}
              {totalDisplayAmt}
          </TableCell>
          <TableCell
            sx={{
              backgroundColor: "#FFF",
              position: "sticky",
              right: 0,

              zIndex: 1
            }}></TableCell>
        </TableRow>
      </TableBody>
    </>
  );
}

export default TotalAmountsTable;
